import { memo } from 'react'

import { Avatar, AvatarFallback, AvatarImage } from '@radix-ui/react-avatar'

import { classNames } from '@/utils/helpers'
import { getInitials } from '@/utils/string.ts'

interface TeamAvatarProps {
  name: string
  avatarSrc?: string | null
  size?: number
  className?: string
}

function isUiAvatar(avatarSrc: string | null) {
  return !!avatarSrc?.includes('ui-avatars.com')
}

export const TeamAvatar = memo(
  ({ name, avatarSrc, size, className }: TeamAvatarProps) => {
    const initials = getInitials(name)

    return (
      <Avatar
        className={classNames(
          'flex justify-center overflow-hidden rounded-full bg-secondary-100 align-middle',
          className,
        )}
        style={{ width: size, height: size }}
        title={name}
      >
        {avatarSrc && (
          <AvatarImage
            src={isUiAvatar(avatarSrc) ? undefined : avatarSrc}
            alt={`${name} Avatar`}
            className="h-full w-full rounded-full object-cover"
          />
        )}
        <AvatarFallback className="flex h-full w-full items-center justify-center bg-primary-500 leading-[1.7] text-neutral-default">
          {initials}
        </AvatarFallback>
      </Avatar>
    )
  },
  () => true,
)

TeamAvatar.displayName = 'TeamAvatar'
